import React, { useEffect, useState } from "react";
import TopLandingNav from "../TopLandingNav/TopLandingNav";
// import unifiedLogo1 from "../../assets/images/unified-health-logo1.png";
// import unifiedLogo2 from "../../assets/images/unified-health-logo2.png";
// import iconimg from "../../assets/images/icon-1.png";
import fastimg from "../../assets/images/fast.png";
import premiumimg from "../../assets/images/premium.png";
import termplanimg from "../../assets/images/term-plan1.png";
// import medicalimg from "../../assets/images/medical.jpg";
import systemimg from "../../assets/images/system.png";
import personalaccidentimg from "../../assets/images/personal-accident1.png";
// import Testimonial from "../Testimonial/Testimonial";
// import StatsBar from "../StatsBar/StatsBar";

import "./LandingPageStyle.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectedCoverPlanLife } from "../../Redux/LogsRedux/Life/LifeLeadsRedux";
// import { individualMedicalData } from "../../Redux/MedicalRedux";
import Footer from "../Footer/Footer";
import TextInput from "../ui/input/TextInput";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import StatsBar from "../StatsBar/StatsBar";
import Testimonial from "../Testimonial/Testimonial";
import { setLanguage } from "../../Redux/LoadingRedux";
import { useTranslation } from "react-i18next";
import LegalTrustStatus from "../LegalTrustStatus/LegalTrustStatus";

const validationSchema = Yup.object({
  name: Yup.string().required("Full name is required").test('no-script', 'Script tags are not allowed', value => !/<script/i.test(value)),

  mobileNumber: Yup.string()
    .matches(/^\d{8}$/, "Enter 8 digits")
    .required("Mobile number is required"),

  termsCondition: Yup.boolean().oneOf(
    [true],
    "You must accept the Privacy Policy",
  ),
});

function LandingPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t,i18n } = useTranslation();
  const initialValues = {
    name: "",
    mobileNumber: "",
    termsCondition: false,
  };

  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    termsCondition: false,
  });

  const handleSubmit = async(values) => {
    let PARTNER_ID = sessionStorage.getItem("PARTNER_ID");
     if (!PARTNER_ID) {
      try {
        await dispatch({ type: 'domain/checkDomain' });
        await new Promise(resolve => setTimeout(resolve, 500));
        PARTNER_ID = sessionStorage.getItem('PARTNER_ID');
        
      } catch (error) {
        console.error('Error fetching PARTNER_ID:', error);
        return;
      }
    }
    const data = {
      partnerId: PARTNER_ID,
      journeyCode: "LIFE",
      fullName: values.name,
      mobileNo: values.mobileNumber,
      leadStatus: "CREATED",
      journeyStatus: "INITIATED",
    };
    dispatch(selectedCoverPlanLife(data)).then((response) => {
      if (response && response.success) {
        localStorage.setItem("LIFE_LEAD_ID", response.data);
        navigate("/choose-your-product", { state: { ...values } });
      }
    });
  };

  const handleKeyPress = (e, plan) => {
    // trigger click on Enter or Space for accessibility
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleSubmit(plan);
    }
  };

  // const { individualDetails } = useSelector((state) => state.MedicalRedux);

  useEffect(() => {
    localStorage.removeItem("LIFE_LEAD_ID");
    localStorage.removeItem("LIFE_QUOTE_ID");
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.15 },
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
      i18n.changeLanguage('en');
      dispatch(setLanguage('en'));
    },[dispatch]);


  return (
    <>
      <div>
        <TopLandingNav />
      </div>
      <div
        className="heroImg"
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <div className="container-fluid  p-4 rounded">
          <div className="container section-header">
            <div className="row align-items-start">
              <div className="col-12 col-lg-7">
                <h2 className="section-text">LIFE INSURANCE</h2>
                {/* <div className="row bg-image-medical">
                    <p className="bg-text">GET YOUR MEDICAL INSURANCE POLICY</p>
                    <p className="bg-text2">Protect your life with medical insurance</p> 
                </div> */}
              </div>

              <div className="col-12 col-lg-5  mt-5 mt-lg-0 bg-white">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="row shadow p-3 mb-1 rounded">
                        {/* Name */}
                        <div className="col-md-12 mt-4">
                          <TextInput
                            label="Name"
                            type="text"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Name"
                            required
                            error={touched.name && errors.name}
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        {/* Mobile Number */}
                        <div className="col-md-12 mt-1">
                          <TextInput
                            label="Mobile Number"
                            type="tel"
                            name="mobileNumber"
                            value={values.mobileNumber}
                            inputMode="numeric"
                            placeholder="Mobile Number"
                            required
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, "");
                              if (val.length <= 8) {
                                setFieldValue("mobileNumber", val);
                              }
                            }}
                            error={touched.mobileNumber && errors.mobileNumber}
                          />
                          <ErrorMessage
                            name="mobileNumber"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        {/* Terms & Conditions */}
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="customCheck"
                              checked={values.termsCondition}
                              onChange={(e) =>
                                setFieldValue(
                                  "termsCondition",
                                  e.target.checked,
                                )
                              }
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor="customCheck"
                            >
                              I accept the&nbsp;
                              <a href="https://dhofarinsurance.com/privacy-policy/">
                                <span className="text-decoration-underline primary-text">
                                  Privacy Policy
                                </span>
                              </a>
                            </label>

                            <ErrorMessage
                              name="termsCondition"
                              component="div"
                              className="text-danger small mt-1"
                            />
                          </div>
                        </div>

                        {/* Submit */}
                        <div className="col-md-12">
                          <button
                            type="submit"
                            className="btn btn-primary mb-4 mt-3"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white">
        <div className="container">
          <div className="row serviceBlock reveal delay-1">
            <div className="col-md-4 d-flex">
              <div className="card p-3 text-bg-light flex-row h-100 w-100">
                <div className="img">
                  <img src={systemimg} alt="icon" className="card-img-top" />
                </div>
                <div className="card-body py-0 d-flex flex-column justify-content-center">
                  <h5 className="card-title">Protect Your Loved Ones</h5>
                  <p className="card-text">
                    Financial security for your family with comprehensive life insurance plans.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="card p-3 text-bg-light flex-row h-100 w-100">
                <div className="img">
                  <img src={premiumimg} alt="icon" className="card-img-top" />
                </div>
                <div className="card-body py-0 d-flex flex-column justify-content-center">
                  <h5 className="card-title">Flexible & Affordable Plans</h5>
                  <p className="card-text">
                    Choose from a range of plans designed to fit your lifestyle and budget.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="card p-3 text-bg-light flex-row h-100 w-100">
                <div className="img">
                  <img src={fastimg} alt="icon" className="card-img-top" />
                </div>
                <div className="card-body py-0 d-flex flex-column justify-content-center">
                  <h5 className="card-title">Simple Claims Process</h5>
                  <p className="card-text">
                    Quick, transparent, and hassle-free claim settlement when it matters most.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Beige */}
      <div className="container-fluid px-0">
        <section className="angled-section angled--beige reveal">
          <div className="container py-3">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 px-5">
                <h2>Personal Accident</h2>
                <p>
                  Our Personal Accident Insurance plan provides financial
                  protection against unforeseen accidents, ensuring you and your
                  family stay secure during unexpected situations. Whether at
                  work, traveling, or at home, this plan covers accidental
                  death, permanent disability, and medical expenses arising from
                  accidents. Stay protected with reliable coverage designed for
                  your safety and peace of mind.
                </p>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="beigeImg">
                  <img
                    src={personalaccidentimg}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* White */}
      <div className="container-fluid px-0">
        <section className="angled-section-white angled--white reveal delay-2">
          <div className="container mt-5">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="whiteImg">
                  <img src={termplanimg} alt="icon" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 px-5">
                <h2>Term Plan</h2>
                <p>
                  Our Term Insurance Plan offers pure life protection to
                  safeguard your family’s financial future in your absence. With
                  high coverage at affordable premiums, this plan ensures your
                  loved ones stay financially secure by covering outstanding
                  liabilities, daily living expenses, children’s education, and
                  long-term goals. Get peace of mind knowing your family is
                  protected when they need it most.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Beige */}
      {/* <div className="container-fluid px-0">
        <section className="angled-section last angled--beige reveal testimonial">
          <div className="container py-3">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12 px-5">
                <Testimonial
                  quote="ZERO has been a game-changer for our car subscriptions, giving everyone peace of mind while ensuring we never miss a payment. It’s seamless, reliable, and keeps our revenue steady — even when life throws curveballs at our customers."
                  author="SARA BAY"
                  company="X-MOBILITY"
                />
              </div>
            </div>
          </div>
        </section>
      </div> */}

      {/* White */}

      <LegalTrustStatus/>
      {/* <div className="container-fluid px-0 bg-white">
        <section className="testimonialWrapper">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12 px-5">
                <div className="statusHighlight">
                  <StatsBar />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}
      <Footer />
    </>
  );
}

export default LandingPage;
